import styled from "@emotion/styled";

export const PageDetailsAndMenu = styled.div`
  display: flex;
`;
export const Content = styled.div`
  width: 100%;
`;
